import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5b7912e1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5b7912e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../Com.GamerSky.App.GameTools/GamerSky.recordInquiry/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7912e1",
  null
  
)

export default component.exports